import React from 'react';
import { withAuth0 } from '@auth0/auth0-react';
import { CookieWrapper } from '../helpers/shared-variables';
import PropTypes from 'prop-types';

const Logout = ( props ) => {
	const domain = process.env.REACT_APP_COOKIE_DOMAIN;
	CookieWrapper.remove( 'user', { domain: domain } );
	CookieWrapper.remove( 'token', { domain: domain } );
	window.localStorage.clear();
	props.auth0.logout();

	return ( <></> );
};

Logout.propTypes = {
	auth0: PropTypes.object,
};

export default withAuth0( Logout );
